module.exports = '6789BCDFGHJKLMNPQRTWbcdfghjkmnpqrtwz';